// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3Qb6s","colMin":"styles_colMin__2aUi2","colCheckbox":"styles_colCheckbox__2BPnE"};